import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

if (document.querySelector('.list-v3')) {
    // Configurazione per i 4 elementi
    const parallaxConfigs = [
        { direction: 1, yMovement: 50, scrub: 0.6, mobileYMovement: 20 },  // Elemento 1
        { direction: -1, yMovement: 70, scrub: 0.9, mobileYMovement: 25 }, // Elemento 2
        { direction: 1, yMovement: 60, scrub: 1.2, mobileYMovement: 22 },  // Elemento 3
        { direction: -1, yMovement: 80, scrub: 1.5, mobileYMovement: 30 }  // Elemento 4
    ];

    // Funzione per verificare se il dispositivo è mobile
    const isMobile = () => window.innerWidth <= 768;

    // Seleziona tutti gli elementi .list-parallax__item
    const listParallaxItems = document.querySelectorAll('.list-parallax__item');

    // Itera su ogni .list-parallax__item per applicare l'effetto parallasse
    listParallaxItems.forEach((item, index) => {
        const config = parallaxConfigs[index % parallaxConfigs.length];

        gsap.fromTo(item, 
            { y: 0 }, // Posizione iniziale
            {
                y: () => isMobile() ? config.mobileYMovement * config.direction : config.yMovement * config.direction,
                scrollTrigger: {
                    trigger: item,
                    start: "top bottom", // Quando l'elemento entra nella viewport
                    end: "bottom top",   // Quando l'elemento esce dalla viewport
                    scrub: config.scrub, // Valore di scrub definito
                    markers: false,      // Mostra i marker di debug (rimuovili in produzione)
                    toggleActions: "restart pause reverse pause"
                }
            }
        );
    });

    // Aggiorna l'effetto parallasse quando la finestra viene ridimensionata
    window.addEventListener('resize', () => {
        ScrollTrigger.refresh();
    });
}
